<template>
  <div class="d-flex">
    <v-simple-checkbox
      color="secondary"
      :ripple="false"
      :value="activityType === 'weekly' ? item.comms.completed_weekly : item.comms.completed_am"
      @input="$emit('update-am')"
    />
    <v-simple-checkbox
      v-if="activityType !== 'weekly'"
      color="secondary"
      :ripple="false"
      :value="item.comms.completed_pm"
      class="pl-2"
      @input="$emit('update-pm')"
    />
  </div>
</template>

<script>
export default {
  name: "Comms",
  props: {
    item: {
      type: Object,
      required: true,
    },
    activityType: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
